import { Link } from 'react-router-dom';
import Logo from './Logo';

const footerLinks = {
  Product: [
    { label: 'Features', to: '/features' },
    { label: 'Pricing', to: '/pricing' },
    { label: 'Security', to: '/security' },
    { label: 'MCP Docs', to: '/docs/mcp' },
  ],
  Resources: [
    { label: 'Migration', to: '/migrate' },
    { label: 'Support', to: '/support' },
    { label: 'Documentation', to: '/support' },
  ],
  Company: [
    { label: 'Contact', to: '/contact' },
    { label: 'Privacy', to: '/privacy' },
    { label: 'Terms', to: '/terms' },
  ],
};

export default function PublicFooter() {
  return (
    <footer className="bg-navy-900 text-white">
      <div className="mx-auto max-w-7xl 2xl:max-w-[1400px] 3xl:max-w-[1600px] px-6 lg:px-8 py-16 2xl:py-20">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          {/* Brand column */}
          <div className="col-span-2 md:col-span-1">
            <Logo className="h-12 w-auto mb-4 brightness-0 invert" />
            <p className="text-sm text-gray-400 max-w-xs leading-relaxed">
              The compliance operating system for banks and credit unions. Marketing compliance, HMDA filing, fair lending analysis, exam management, and regulatory intelligence.
            </p>
          </div>

          {/* Link columns */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="text-xs font-semibold text-white uppercase tracking-wider font-mono mb-4">
                {category}
              </h3>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-gray-400 hover:text-white transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-400">
            &copy; 2026 Avancee LLC. Clarid&trade; is a trademark of Avancee LLC.
          </p>
          <p className="text-xs text-gray-400">
            Trademark Serial No. 99170235
          </p>
        </div>
      </div>
    </footer>
  );
}
